module.exports = __webpack_public_path__ + "4499d78613d422b1311100f5f17d86cb.svg";